import { TYPOGRAPHY_COLORS } from 'constants/TypographyColors'
import { SVGIcon } from './SvgIcon/SvgIcon'
import { IconProps } from './types'

export const ProfileIcon = ({
  size,
  color = 'grey400',
  className,
}: IconProps) => (
  <SVGIcon size={size} color={color} className={className} viewBox="0 0 20 20">
    <path
      d="M10.0004 1.45361C14.7205 1.45361 18.5469 5.28002 18.5469 10.0001C18.5469 14.7202 14.7205 18.5466 10.0004 18.5466C5.28031 18.5466 1.45391 14.7202 1.45391 10.0001C1.45391 5.28002 5.28031 1.45361 10.0004 1.45361Z"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6055 15.4233C16.6055 15.4233 14.7004 12.9912 9.99984 12.9912C5.2993 12.9912 3.39414 15.4233 3.39414 15.4233"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0005 9.99996C8.58438 9.99996 7.43648 8.85207 7.43648 7.43598C7.43648 6.01996 8.58438 4.87207 10.0005 4.87207C11.4166 4.87207 12.5645 6.01996 12.5645 7.43598C12.5645 8.85207 11.4166 9.99996 10.0005 9.99996Z"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVGIcon>
)
